import { Investor, User } from '../../login/redux/types';
import { InvestorStatus } from '../../login/utils/Status';
import { ONBOARDING_PATH } from './Onbording';

export interface StepperStep {
    isCompleted: boolean;
    isActive: boolean;
    step: number;
    url?: ONBOARDING_PATH;
}
export interface Steppers {
    label: string;
    isCompleted: boolean;
    steps: StepperStep[];
    step: number;
    url?: ONBOARDING_PATH;
}

interface Preferences {
    investmentTypes?: string[];
    investmentHorizon?: string[];
    riskPreference?: string[];
    geographies?: string[];
    sectors?: string[];
    ticketSize?: string[];
}

export const checkPrefrencesData = (preferences?: Preferences) => {
    if (
        preferences &&
        preferences.investmentTypes &&
        preferences.investmentHorizon &&
        preferences.riskPreference &&
        preferences.geographies &&
        preferences.sectors &&
        preferences.ticketSize
    ) {
        if (
            preferences.investmentTypes.length > 0 &&
            preferences.investmentHorizon.length > 0 &&
            preferences.riskPreference.length > 0 &&
            preferences.geographies.length > 0 &&
            preferences.sectors.length > 0 &&
            preferences.ticketSize.length > 0
        ) {
            return true;
        }
        return false;
    }
    return false;
};

export const createOnboardingArray = (user?: User, investor?: Investor) => {
    const NDA = investor?.agreements?.find((a) => a.agreementType === 'NDA');
    const sidebar: Steppers[] = [
        {
            label: 'Profile',
            isCompleted:
                user?.userProfile?.name &&
                user?.userProfile?.phoneNumber &&
                user?.userProfile?.phoneNumber.number &&
                investor?.investorType &&
                investor?.profile &&
                ((investor.investorType === 'Individual Accredited' && investor.profile.employmentStatus) ||
                    ((investor.investorType === 'Institutional' || investor.investorType === 'Corporate Accredited') &&
                        investor.profile.companyName))
                    ? true
                    : false,
            step: 1,
            url: ONBOARDING_PATH.BASIC_PROFILE,
            steps: [
                {
                    isCompleted:
                        user?.userProfile?.name &&
                        user?.userProfile?.phoneNumber &&
                        user?.userProfile?.phoneNumber.number
                            ? true
                            : false,
                    isActive: false,
                    step: 1,
                    url: ONBOARDING_PATH.BASIC_PROFILE,
                },
                {
                    isCompleted: investor?.investorType ? true : false,
                    isActive: false,
                    step: 2,
                    url: ONBOARDING_PATH.ACCREDITATION,
                },
                {
                    isCompleted:
                        investor?.profile &&
                        ((investor.investorType === 'Individual Accredited' && investor.profile.employmentStatus) ||
                            (investor.investorType === 'Institutional' && investor.profile.companyName) ||
                            (investor.investorType === 'Corporate Accredited' && investor.profile.companyName))
                            ? true
                            : false,
                    isActive: false,
                    step: 3,
                    url: ONBOARDING_PATH.INVESTOR_PROFILE,
                },
            ],
        },
        {
            label: 'NDA',
            isCompleted:
                NDA?.lastAudit.at && investor?.status?.profile !== InvestorStatus.PendingNDA && !NDA.shouldResign
                    ? true
                    : false,
            steps: [],
            step: 2,
            url: ONBOARDING_PATH.NDA,
        },
        {
            label: 'Investment Preferences',
            isCompleted:
                investor?.preferences &&
                investor.preferences.geographies &&
                investor.preferences.geographies.length > 0 &&
                investor.preferences.investmentHorizon &&
                investor.preferences.investmentHorizon.length > 0 &&
                investor.preferences.investmentTypes &&
                investor.preferences.investmentTypes.length > 0 &&
                investor.preferences.riskPreference &&
                investor.preferences.riskPreference.length > 0 &&
                investor.preferences.sectors &&
                investor.preferences.sectors.length > 0 &&
                investor.preferences.ticketSize &&
                investor.preferences.ticketSize.length > 0
                    ? true
                    : false,
            step: 3,
            url: ONBOARDING_PATH.INVESTMENT_PREFERENCES,
            steps: [
                {
                    isCompleted:
                        investor?.preferences &&
                        investor.preferences.investmentTypes &&
                        investor.preferences.investmentTypes.length > 0
                            ? true
                            : false,
                    isActive: true,
                    step: 1,
                },
                {
                    isCompleted:
                        investor?.preferences &&
                        investor.preferences.investmentHorizon &&
                        investor.preferences.investmentHorizon.length > 0 &&
                        investor.preferences.riskPreference &&
                        investor.preferences.riskPreference.length > 0
                            ? true
                            : false,
                    isActive: false,
                    step: 2,
                },
                {
                    isCompleted:
                        investor?.preferences &&
                        investor.preferences.ticketSize &&
                        investor.preferences.ticketSize.length > 0
                            ? true
                            : false,
                    isActive: false,
                    step: 3,
                },
                {
                    isCompleted:
                        investor?.preferences &&
                        investor.preferences.geographies &&
                        investor.preferences.geographies.length > 0
                            ? true
                            : false,
                    isActive: false,
                    step: 4,
                },
                {
                    isCompleted:
                        investor?.preferences && investor.preferences.sectors && investor.preferences.sectors.length > 0
                            ? true
                            : false,
                    isActive: false,
                    step: 5,
                },
            ],
        },
        {
            label: 'Accreditation',
            isCompleted:
                investor?.status?.accreditation !== 'NA' &&
                investor?.status?.accreditation !== '' &&
                investor?.status?.accreditation &&
                investor?.status?.accreditation !== InvestorStatus.PendingAISubmission &&
                investor?.status?.accreditation !== InvestorStatus.PendingAIResubmission &&
                investor?.status?.accreditation !== InvestorStatus.PendingAIAdditionalDetails
                    ? true
                    : false,
            url: ONBOARDING_PATH.ACCREDITED_INVESTOR,
            steps: [],
            step: 4,
        },
        {
            label: 'KYC',
            isCompleted:
                investor?.kyc?.info &&
                investor?.status?.kyc !== InvestorStatus.PendingKYCSubmission &&
                investor?.status?.kyc !== InvestorStatus.PendingKYCAdditionalDetails
                    ? true
                    : false,
            url: ONBOARDING_PATH.KYC,
            steps: [],
            step: 5,
        },
    ];
    return sidebar;
};

export const onboardingCompletedPercentage = (user?: User, investor?: Investor) => {
    let percetage = 0;
    const NDA = investor?.agreements?.find((a) => a.agreementType === 'NDA');
    if (user?.userProfile?.name && user.userProfile.phoneNumber && user.userProfile.phoneNumber.number) {
        percetage = percetage + 10;
    }

    if (investor?.investorType) {
        percetage = percetage + 10;
    }

    if (
        investor?.profile &&
        ((investor.investorType === 'Individual Accredited' && investor.profile.employmentStatus) ||
            ((investor.investorType === 'Institutional' || investor.investorType === 'Corporate Accredited') &&
                investor.profile.companyName))
    ) {
        percetage = percetage + 10;
    }

    if (NDA?.lastAudit.at && investor?.status?.profile !== InvestorStatus.PendingNDA) {
        percetage = percetage + 10;
    }

    if (
        investor?.preferences &&
        investor.preferences.investmentTypes &&
        investor.preferences.investmentTypes.length > 0
    ) {
        percetage = percetage + 10;
    }

    if (
        investor?.preferences &&
        investor.preferences.investmentHorizon &&
        investor.preferences.investmentHorizon.length > 0 &&
        investor.preferences.riskPreference &&
        investor.preferences.riskPreference.length > 0
    ) {
        percetage = percetage + 10;
    }

    if (investor?.preferences && investor.preferences.ticketSize && investor.preferences.ticketSize.length > 0) {
        percetage = percetage + 10;
    }

    if (investor?.preferences && investor.preferences.geographies && investor.preferences.geographies.length > 0) {
        percetage = percetage + 10;
    }

    if (investor?.preferences && investor.preferences.sectors && investor.preferences.sectors.length > 0) {
        percetage = percetage + 10;
    }
    if (
        investor?.investorType !== 'Institutional' &&
        // investor?.accreditation?.documents &&
        // investor?.accreditation?.documents.length > 0 &&
        // investor?.accreditation?.documents[0].qualificationStatus &&
        // investor?.accreditation?.documents[0].docs &&
        // investor?.accreditation?.documents[0].docs.length > 0 &&
        investor?.status?.accreditation !== 'NA' &&
        investor?.status?.accreditation !== '' &&
        investor?.status?.accreditation &&
        investor?.status?.accreditation !== InvestorStatus.PendingAISubmission &&
        investor?.status?.accreditation !== InvestorStatus.PendingAIResubmission
    ) {
        percetage = percetage + 5;
    }
    if (
        investor?.kyc?.info &&
        investor?.status?.kyc !== InvestorStatus.PendingKYCSubmission &&
        investor?.status?.kyc !== InvestorStatus.PendingKYCAdditionalDetails
    ) {
        percetage = percetage + (investor?.investorType !== 'Institutional' ? 5 : 10);
    }

    return percetage;
};
